import dayjs from "dayjs";

import { Schema } from "./schema";
import {
  COMMON_LANGUAGES,
  LanguagesSchema,
  ReviewsLanguagesOptions,
} from "../../../../HookForm/LanguageSelect/types";

export const generateCreateFacilityReportPayload = (data: Schema) => {
  const languages = getReviewsLanguages(data.options.reviews.languages);
  return {
    facility_ids: data.locations.map((location) => location.id.toString()),
    start_date: dayjs(data.timespan.start_date).format("YYYY-MM-DD"),
    end_date: dayjs(data.timespan.end_date).format("YYYY-MM-DD"),
    options: {
      ...data.options,
      reviews: {
        is_enabled: data.options.reviews.is_enabled,
        languages: languages,
      },
    },
  };
};

const getReviewsLanguages = (data: LanguagesSchema) => {
  if (data.option === ReviewsLanguagesOptions.JAPANESE_ONLY) {
    return ["ja"];
  }
  if (data.option === ReviewsLanguagesOptions.ALL) {
    return COMMON_LANGUAGES;
  }
  return data.custom_values;
};
